import { U as UsernameAlias } from './auth-types-78df304e.js';
import { Hub } from '@aws-amplify/core';
import { U as UI_AUTH_CHANNEL, T as TOAST_AUTH_ERROR_EVENT, a as AUTH_STATE_CHANGE_EVENT, P as PHONE_EMPTY_ERROR_MESSAGE } from './constants-206817b9.js';

var hasShadowDom = function hasShadowDom(el) {
  return !!el.shadowRoot && !!el.attachShadow;
};

var dispatchToastHubEvent = function dispatchToastHubEvent(error) {
  Hub.dispatch(UI_AUTH_CHANNEL, {
    event: TOAST_AUTH_ERROR_EVENT,
    message: error.message
  });
};

var dispatchAuthStateChangeEvent = function dispatchAuthStateChangeEvent(nextAuthState, data) {
  Hub.dispatch(UI_AUTH_CHANNEL, {
    event: AUTH_STATE_CHANGE_EVENT,
    message: nextAuthState,
    data: data
  });
};

var composePhoneNumberInput = function composePhoneNumberInput(phoneNumber) {
  if (!phoneNumber.phoneNumberValue) {
    throw new Error(PHONE_EMPTY_ERROR_MESSAGE);
  }

  var sanitizedPhoneNumberValue = phoneNumber.phoneNumberValue.replace(/[-()\s]/g, '');
  return "" + phoneNumber.countryDialCodeValue + sanitizedPhoneNumberValue;
};

var checkUsernameAlias = function checkUsernameAlias(usernameAlias) {
  if (!(usernameAlias in UsernameAlias)) {
    throw new Error("Invalid username Alias - " + usernameAlias + ". Instead use " + Object.values(UsernameAlias));
  }
};

export { dispatchToastHubEvent as a, composePhoneNumberInput as b, checkUsernameAlias as c, dispatchAuthStateChangeEvent as d, hasShadowDom as h };